import type { Seo } from '~/types/layouts/seo';

export function getRobots(data: Seo | undefined | null) {
  if (!data?.robots) return null;

  const res: Robots = {
    noarchive: data.robots.noarchive,
  };

  if (data.robots.index) {
    res[data.robots.index] = true;
  }

  if (data.robots.follow) {
    res[data.robots.follow] = true;
  }

  if (data.robots.all) {
    res[data.robots.all] = true;
  }

  return res;
}

interface Robots {
  index?: boolean;
  noindex?: boolean;
  follow?: boolean;
  nofollow?: boolean;
  all?: boolean;
  none?: boolean;
  noarchive?: boolean;
}

export function getPageUrlTemplatedTag({
  value,
  siteUrl,
  pagePath,
}: {
  value: string | null | undefined;
  siteUrl: string;
  pagePath: string;
}) {
  if (value === 'PAGE_URL') {
    return siteUrl + pagePath;
  } else {
    return isHttpsUrl(value) ? value : undefined;
  }
}

export function getMetaTitleTemplatedTag({
  value,
  data,
}: {
  value: string | undefined | null;
  data: Seo | undefined | null;
}) {
  if (value === 'META_TITLE') {
    return data?.title;
  } else {
    return value;
  }
}

export function getMetaDescriptionTemplatedTag({
  value,
  data,
}: {
  value: string | undefined | null;
  data: Seo | undefined | null;
}) {
  if (value === 'META_DESCRIPTION') {
    return data?.description;
  } else {
    return value;
  }
}

export function getOgImageUrl(data: Seo | undefined | null) {
  if (data?.ogTags?.ogImage?.url) {
    const { getCompleteUrl } = useCompleteStrapiUrl();
    return getCompleteUrl(data.ogTags.ogImage.url);
  }
}

export function getOgImageSecureUrl(data: Seo | undefined | null) {
  if (data?.ogTags?.ogImageSecureUrl === 'og:image') {
    return getOgImageUrl(data);
  } else {
    return data?.ogTags?.ogImageSecureUrl;
  }
}

export function getOgImageAlt(data: Seo | undefined | null) {
  if (data?.ogTags?.ogImageAlt === 'og:title') {
    return getMetaTitleTemplatedTag({
      value: data?.ogTags?.ogTitle,
      data,
    });
  } else {
    return data?.ogTags?.ogImageAlt;
  }
}

export function getArticleAuthor(data: Seo | undefined | null) {
  if (data?.articleTags?.articleAuthor) {
    return [data!.articleTags!.articleAuthor!];
  }
}

export function getArticleTag(data: Seo | undefined | null) {
  if (data?.articleTags?.articleTag) {
    return [data!.articleTags!.articleTag!];
  }
}

export function getSiteUrlTemplatedTag({
  value,
  siteUrl,
}: {
  value: string | undefined | null;
  siteUrl: string;
}) {
  if (value === 'SITE_URL') {
    return siteUrl;
  } else {
    return value;
  }
}

export function getTwitterImageAlt(data: Seo | undefined | null) {
  if (data?.twitterTags?.twitterImageAlt === 'twitter:title') {
    return getMetaTitleTemplatedTag({
      value: data?.twitterTags?.twitterTitle,
      data,
    });
  } else {
    return data?.twitterTags?.twitterImageAlt;
  }
}
